import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { GeneralContainer, LinkSection, Subtitle, Row,RowButton, TexBody,IconContainer, ColumnHeader, DepartmentName, LocationSelect, DrawerContainer, DrawerOptionsContainer, DrawerList, LocationPicker, SaveButton, IconWrapper, Explanation, Tools } from './styles';
import { MainContainer, TabBody, TitleContainer, SeparatorW, SeparatorH, Title } from 'features/Dealers/DealerConfiguration/styles'
import { Info,ToolTipContainer,ToolTipLabel } from '../styles';
import { BoxContainer1, BoxContainer2 } from './styles';
import { NONE_DISPLAY } from './state/constants'
import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';
import { FilterSuggestDrawerItem } from 'components/SearchableDropdown/SearchableDropdownItem';
import { ReactComponent as IconToolTip } from 'common/images/icon-tootltip-orange.svg'
import { ReactComponent as IconX } from 'common/images/icon-unlink.svg'
import { UIDepartments, UIDepartment, EngineLocation } from 'features/Dealers/DealerConfiguration/Departments/state/types';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { serviceLoading } from 'common/loaderReducer';
import { GET_LMDEPARTMENTS_API_REQUEST, POST_LISTINGS_API_REQUEST } from 'features/Dealers/DealerConfiguration/Departments/state/actionTypes';
import { editLiveDepartments, postListingAPI } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import { EngineLocations } from 'features/Dealers/DealerConfiguration/Departments/state/types';
import { ListingType, ListingUI } from 'features/Dealers/Listings/state/types';
import { DepartmentsTitle } from 'features/Dealers/DealerConfiguration/Departments/Title';
import { DepartmentsHeaders } from 'features/Dealers/DealerConfiguration/Departments/Headers';
import { DepartmentsButtons } from 'features/Dealers/DealerConfiguration/Departments/Buttons';
import { useHistory } from 'react-router';
import InnerLoader from 'components/InnerLoader';
import info from 'common/images/icon-info.svg';



interface location {
    displayName: string;
}

interface department {
    displayName: string;
    location: location;
    id: string;
}

interface LMDepartmentsProps {
    isLoading: boolean
    isSaving: boolean
    departments?: UIDepartments
    locations?: EngineLocations
    selectedDealer?: Dealer
    liveDepartments?: UIDepartment[]
    listings: ListingUI[]
}

const EditDepartments = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [drawer, setDrawer] = React.useState<HTMLDivElement | null>(null)
    const [focusedIndex, setFocusedIndex] = React.useState(-1);
    const [drawerToShow, setDrawerToShow] = React.useState(NONE_DISPLAY)
    const previousSavingState = React.useRef(false)

    const {
        isLoading,
        isSaving,
        departments,
        locations,
        selectedDealer,
        liveDepartments,
        listings,
    }: LMDepartmentsProps = useSelector((rootState: RootState) => {
        const listingsByDealerId = rootState.dealers.listing.listings.byDealerId;
        const selectedDealer = rootState.dealers.dealer.selectedDealer;
        let listings: ListingUI[] = []
        if (listingsByDealerId[selectedDealer?.id ?? ""]) {
            listings = listingsByDealerId[selectedDealer?.id ?? ""];
        }

        return {
            isLoading: serviceLoading(rootState, [GET_LMDEPARTMENTS_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_LISTINGS_API_REQUEST]),
            departments: rootState.dealers.departments.departments,
            locations: rootState.dealers.departments.engineLocations,
            listings,
            selectedDealer,
            liveDepartments: rootState.dealers.departments.liveDepartments,
        }
    }, shallowEqual);

    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [drawer]);

    React.useEffect(() => {
        const newLiveDepartments = departments?.departments.map(department => {
            const id = department.name;
            let listingFound: ListingUI | undefined
            if (listings) {
                listingFound = _.find(listings, { type: ListingType.DEPARTMENT, deparmentId: id })
            }
            return {
                ...department,
                listingId: listingFound ? listingFound.id : undefined,
                engineLocationId: listingFound ? listingFound.idInSource : undefined
            }
        })

        dispatch(editLiveDepartments(newLiveDepartments ?? []));
    }, [])





    const renderType = React.useMemo(() => {
        if (locations && locations.locations.length == 0)
            return 1;
        else {

            if (departments && departments.departments.length == 0)
                return 2;
            else {

                let linkedCount = listings.filter(f=> f.type == ListingType.DEPARTMENT).length;                
                if (linkedCount==0)
                    return 3;
                if (linkedCount == ((departments?departments.departments:0)))
                    return 6
                else
                {
                    if (linkedCount ==1)
                        return 4;
                    else
                        return 5;
                }
            }
        }
    }, [locations, liveDepartments]);


    function handleClickOutside(event) {
        if (drawer && !drawer.contains(event.target)) {
            setDrawerToShow(NONE_DISPLAY)
        }
    }

    return (    
        <GeneralContainer>          
            <TitleContainer >
                <Title>
                {
                    'Status'
                }
                </Title>
            </TitleContainer>
            <BoxContainer1>
            <DepartmentsTitle
                    locations={locations}
                    renderType={renderType}
                    departments={departments}
                />           
            </BoxContainer1>

            {renderType > 2 && 
            <> 
            <TitleContainer >
                <Title>
                {
                    'Link Your Departments'
                }
                </Title>
            </TitleContainer>
            <BoxContainer2>
            <TexBody>
            <LinkSection>

                <DepartmentsHeaders
                    renderType={renderType}
                />
                {
                    renderType > 2 && liveDepartments && liveDepartments.length > 0 && liveDepartments.map(dpt => { return (renderRow(dpt)) })
                }
                {
                        <RowButton>
                            <DepartmentsButtons
                                renderType={renderType}
                                liveDepartments={liveDepartments}
                                isSaving ={isSaving}
                                onSaveClick={onSaveClick}
                            />
                        </RowButton>
                        
                }

            </LinkSection>
            </TexBody>
            </BoxContainer2>
            <div>&nbsp;</div>
            </>}
        </GeneralContainer>
    )



    function locationDisabled(dpt: UIDepartment) {
        return false;
    }


    function onSaveClick(e) {
        if (selectedDealer && liveDepartments) {
            dispatch(postListingAPI("GMB", selectedDealer?.id, liveDepartments))
        }
    }

    function renderRow(dpt: UIDepartment) {


        const listingForDepartment = listings.filter(listing => {
            return listing.type === ListingType.DEPARTMENT && listing.deparmentId === dpt.name;
        })
        let originalLinking = false
        let locationId
        if (listingForDepartment.length > 0) {
            //locationId = listingForDepartment[0].idInSource;
            originalLinking = true
        }


        if (dpt.engineLocationId) {
            locationId = dpt.engineLocationId; //esta sin salvar
            //originalLinking = false
        }

        let engineLocation: EngineLocation | undefined;
        if (locations?.locations) {
            engineLocation = _.find(locations.locations, { locationId });
        }


        return (
            <Row>
                <DepartmentName>
                    {dpt.name}
                </DepartmentName>
                <LocationSelect>
                    <LocationPicker
                        placeholder={'Select a location'}
                        value={engineLocation ? engineLocation?.locationName : ""}
                        onClick={() => showDrawer(dpt.name)}
                        disabled={locationDisabled(dpt)}
                    />
                    {
                        drawerToShow === dpt.name && renderDrawer((engineLocationId) => onSelectLocation(dpt.name, engineLocationId))
                    }
                </LocationSelect>
                {
                    locationId != undefined && (
                        <Tools>
                            <IconWrapper>
                                <IconX onClick={(event) => onUnlinkClick(dpt.name, event)} />
                            </IconWrapper>

                            <Info>
                                <img src={info} style={{marginTop:4}}></img>
                            </Info>
                            <ToolTipContainer>
                                <ToolTipLabel>
                                    Unlink
                                </ToolTipLabel>
                            </ToolTipContainer>
                            
                        </Tools>)
                }
            </Row>
        )
    }

    function onUnlinkClick(departmentName: string, e) {
        if (liveDepartments) {
            const foundDepartmentIndex = _.findIndex(liveDepartments, { name: departmentName });
            if (foundDepartmentIndex !== -1) {
                const updatedDepartment = {
                    ...liveDepartments[foundDepartmentIndex],
                    engineLocationId: undefined
                }

                const allLiveDepartments = [...liveDepartments];
                allLiveDepartments.splice(foundDepartmentIndex, 1, updatedDepartment)

                dispatch(editLiveDepartments(allLiveDepartments))
            }
        }

    }

    function onSelectLocation(departmentName: string, engineLocationId: { id: string }) {

        if (liveDepartments) {
            const foundDepartmentIndex = _.findIndex(liveDepartments, { name: departmentName });
            if (foundDepartmentIndex !== -1) {
                const updatedDepartment = {
                    ...liveDepartments[foundDepartmentIndex],
                    engineLocationId: engineLocationId.id
                }

                const allLiveDepartments = [...liveDepartments];
                allLiveDepartments.splice(foundDepartmentIndex, 1, updatedDepartment)

                dispatch(editLiveDepartments(allLiveDepartments))
            }
        }
        setDrawerToShow(NONE_DISPLAY)
    }


    function showDrawer(id: string) {
        if (drawerToShow === id) {
            setDrawerToShow(NONE_DISPLAY)
        } else {
            setDrawerToShow(id)
        }
    }


    function renderDrawer(onSelect: (SearchableDropdownItem) => void) {
        return (
            <DrawerContainer>
                <DrawerOptionsContainer >
                    <DrawerList
                        ref={(node) => setDrawer(node as any)}
                    >
                        {
                            locations && locations.locations
                                .filter(loc => {

                                    let listingFound: ListingUI | undefined
                                    if (listings) {
                                        listingFound = _.find(listings, { type: ListingType.PRIMARY })
                                        if (listingFound?.idInSource == loc.locationId)
                                            return false;
                                    }
                                    if (liveDepartments) {
                                        return !Boolean(_.find(liveDepartments, { engineLocationId: loc.locationId }))
                                    }
                                    return true
                                })
                                .map((loc, index) => {
                                    const option: SearchableDropdownItem = { id: loc.locationId, displayName: loc.locationName }
                                    return (
                                        <FilterSuggestDrawerItem
                                            option={option}
                                            onOptionSelected={onSelect}
                                            focused={focusedIndex === index}
                                        />
                                    )
                                })
                        }
                    </DrawerList>
                </DrawerOptionsContainer>
            </DrawerContainer>
        )
    }

    function renderExplanation() {
        return (
            <Explanation>
                Unlink
            </Explanation>
        )
    }

    function renderIcon() {
        return (
            <IconWrapper>
                <IconToolTip />
            </IconWrapper>
        )
    }
}

export default EditDepartments

